import { NgModule } from '@angular/core';
import { LoginComponent } from './login.component';
import { VerifyPhoneComponent } from './verify-phone.component';
import { RegisterComponent } from './register.component';
import { LogoutComponent } from './logout.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CustomFormsModule } from 'ng2-validation';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { HttpClientModule } from '@angular/common/http';
import { ForgotPasswordComponent } from './forgot-password.component';
import { SelectModule } from 'ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    CustomFormsModule,
    FlashMessagesModule,
    HttpClientModule,
    SelectModule,
  ],
  declarations: [LoginComponent, RegisterComponent, LogoutComponent, VerifyPhoneComponent, ForgotPasswordComponent],
  exports: [LoginComponent, RegisterComponent, LogoutComponent, VerifyPhoneComponent],
})
export class AuthenticateModule {}



// WEBPACK FOOTER //
// ./src/app/pages/admin/auth/authenticate.module.ts